import type { AdminConferenceAttendance, AdminFeedbackForm } from './admin';

export function feedbackConferenceId(form: AdminFeedbackForm, conferences: AdminConferenceAttendance[]): string | undefined {
  if (form.conferenceId) return conferences.find((conference) => conference.id === form.conferenceId)?.id;

  // The original conference forms predate the explicit conferenceId field.
  if (form.id === '2026-conference-feedback') {
    return conferences.find((conference) => conference.id === '2026-Conference')?.id;
  }

  if (!form.sessionId) return undefined;
  const matches = conferences.filter((conference) => conference.sessions.some((session) => session.id === form.sessionId));
  return matches.length === 1 ? matches[0].id : undefined;
}
